<template>
    <div
        class="fixed bottom-5 left-5 z-40 rounded-full md:bottom-10 md:left-10">
        <NuxtLink
            :to="`${whatsAppLink}`"
            target="_blank"
            aria-label="Перейти в WhatsApp"
            :class="
                isOpen
                    ? '-translate-y-[16.15rem] opacity-100'
                    : 'translate-y-0 opacity-0'
            "
            class="absolute z-10 flex size-20 rounded-full border border-ash-200 bg-white/20 backdrop-blur-md transition-all duration-300 hover:bg-[#00BD39]">
            <AtomIcon
                name="whatsapp"
                class="m-auto size-10" />
        </NuxtLink>

        <NuxtLink
            to="https://max.ru/id780608296104_bot"
            target="_blank"
            aria-label="Перейти в MAX"
            :class="
                isOpen
                    ? '-translate-y-[10.75rem] opacity-100'
                    : 'translate-y-0 opacity-0'
            "
            class="absolute flex size-20 rounded-full border border-ash-200 bg-white/20 opacity-0 backdrop-blur-md transition-all duration-300 hover:bg-[#A458F5]">
            <AtomIcon
                name="max"
                class="m-auto size-9" />
        </NuxtLink>

        <NuxtLink
            to="https://t.me/Cromi_bot"
            target="_blank"
            aria-label="Перейти в Telegram"
            :class="
                isOpen
                    ? '-translate-y-[5.4rem] opacity-100'
                    : 'translate-y-0 opacity-0'
            "
            class="absolute flex size-20 rounded-full border border-ash-200 bg-white/20 opacity-0 backdrop-blur-md transition-all duration-300 hover:bg-[#5878F5]">
            <AtomIcon
                name="telegram"
                class="m-auto size-9" />
        </NuxtLink>

        <button
            :aria-label="`${isOpen ? 'Закрыть' : 'Открыть'} меню с мессенджерами`"
            :class="{
                'border-ash-200/20 bg-white/20 text-ash-200/20 hover:border-ash-200 hover:text-ash-200':
                    !isOpen,
                'border-ash-200 bg-white/20 text-ash-200 hover:bg-white/40':
                    isOpen,
            }"
            class="relative z-20 size-20 rounded-full border backdrop-blur-sm transition-all duration-300"
            @click="isOpen = !isOpen">
            <Transition
                enter-active-class="animate-messenger-spin-in"
                leave-active-class="animate-messenger-spin-out"
                mode="out-in">
                <span
                    v-if="!isOpen"
                    key="open"
                    class="relative block size-full">
                    <AtomIcon
                        name="max"
                        class="absolute left-6 top-2 size-8" />
                    <AtomIcon
                        name="telegram"
                        class="absolute bottom-2 left-1.5 size-8" />
                    <AtomIcon
                        name="whatsapp"
                        class="absolute bottom-2 right-2 size-8" />
                </span>
                <span
                    v-else
                    key="close"
                    class="relative block size-full">
                    <AtomIcon
                        name="close"
                        class="absolute left-1/2 top-1/2 size-9 -translate-x-1/2 -translate-y-1/2" />
                </span>
            </Transition>
        </button>
    </div>
</template>

<script setup lang="ts">
import { messengers } from '~/const/company-info.consts'

import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'

const isOpen = ref<boolean>(false)

const { data } = await useContactSettings()

const whatsAppLink = computed(() => {
    if (!data.value) return messengers.whatsApp.link

    const api = 'https://api.whatsapp.com/send'
    const phone = String(data.value.data.whatsApp_phone).replace(/^\+7/, '')

    return `${api}?phone=${phone}&text=${data.value.data.whatsApp_message}`
})
</script>
